import React from 'react'
import { ElementProps } from '../models'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'

const DateField = ({
  component,
  state,
  handleChange,
  disabled = false,
  errorMessage,
}: ElementProps) => {
  return (
    <div className='fieldSet'>
      <FieldLabel label={component.label} required={component.required} />
      <div>
        <input
          type='datetime-local'
          value={state[component.reference] || ''}
          disabled={disabled}
          onChange={(e) => handleChange(e.target.value, component)}
          style={errorMessage ? { borderColor: 'red' } : {}}
          name={component.reference}
        />
        <ErrorMessage errorMessage={errorMessage} />
      </div>
    </div>
  )
}

export default DateField
